import React, { useEffect, useRef, useState, useMemo } from 'react';
import { IconArrowDown, IconArrowUp } from '@tabler/icons-react';
import { COLORS } from '@app/constants';
import { Text, View } from '@/styles/reactnative';
import { CurrentPrice, OrderBookCurrentPriceWrapper } from './styles';
import BigNumber from 'bignumber.js';
import { useSetting, getSetting } from '../../../../hooks/user/mysetting';
import { useFetcherPublic } from '../../../../hooks/fetcher';
import { SETTING_TYPE_SYSTEM } from '../../../../constants/SETTING';
import useTradeStore from '../../../../hooks/trade/tradeStore';
import { truncateWithComma } from '@utils/Truncate.ts';

const OrderBookCurrentPrice = ({ tradeDataP }) => {
  const { data: store } = useTradeStore();
  const { data: setting } = useSetting(SETTING_TYPE_SYSTEM);
  const { data: result } = useFetcherPublic('/system/currency');

  const currency = getSetting(setting, 'CURRENCY', 'USD');

  const currentCurrency = useMemo(() => {
    return result?.result?.result?.find((item: any) => item.code === currency);
  }, [result, currency]);

  const symbol = store?.pairs?.replace('/', '').toLowerCase();
  const isPepe = symbol === 'pepeusdt';

  const prevPriceRef = useRef<number>(0);
  const [price, setPrice] = useState<number>(0);

  useEffect(() => {
    if (!tradeDataP) return;

    const newPrice = isPepe
      ? parseFloat(tradeDataP) * 1000
      : parseFloat(tradeDataP);

    if (newPrice !== price) {
      prevPriceRef.current = price;
      setPrice(newPrice);
    }
  }, [tradeDataP, isPepe, price]);

  const isUp = price >= prevPriceRef.current;

  return (
    <OrderBookCurrentPriceWrapper>
      <View style={{ flexDirection: 'row', marginRight: 15, gap: 4 }}>
        {isUp ? (
          <IconArrowUp size={20} color={COLORS.lightGreen} />
        ) : (
          <IconArrowDown size={20} color={COLORS.lightRed} />
        )}
        <CurrentPrice $color={isUp ? COLORS.green : COLORS.lightRed}>
          {truncateWithComma(
            BigNumber(price).toNumber(),
            store?.pairs?.toLowerCase() === 'pepe/usdt' ? 7 : store?.dp
          )}
        </CurrentPrice>
      </View>

      <View>
        <Text
          size={12}
          style={{ color: COLORS.lightGray, whiteSpace: 'nowrap' }}
        >
          ≒{' '}

          {new BigNumber(price)
            .multipliedBy(currentCurrency?.price || 1)
            .toFormat(0)}{' '}
          {currentCurrency?.symbol}
        </Text>
      </View>
    </OrderBookCurrentPriceWrapper>
  );
};

export default React.memo(
  OrderBookCurrentPrice,
  (prev, next) => prev.tradeDataP === next.tradeDataP
);
